import React from "react";
import Delete from "../../../assets/icon/NewsIcons/MainAdmin/NewsDelete";
import Detail from "../../../assets/icon/NewsIcons/MainAdmin/NewsDetail";
import { ReactComponent as Right } from "../../../assets/icon/right.svg";
import { ReactComponent as Left } from "../../../assets/icon/left.svg";

const MainAdminJobsTable = ({
    detail,
    deleted,
    titleRow,
    writersList,
    setShowDetailModal,
    setShowDeleteModal,
    setData,
    count,
    page,
    setPage,
    row,
    setRow,
}) => {
    return (
        <div className="rounded-[15px] pt-[15px] px-[15px] pb-[120px] border-borderGray border-2 w-full overflow-auto">
            <table className="w-full">
                {titleRow ? (
                    <tr className="h-[60px] w-full bg-lightBlue2">
                        <th className="rounded-r-[15px] text-right pr-[17px] text-[15px] font-IRANYekanBold text-mainColor2">ردیف</th>
                        {titleRow.map((t, i) => (
                            <th key={i} className="text-[15px] text-right font-IRANYekanBold text-mainColor2">{t}</th>
                        ))}
                        <th className="rounded-l-[15px] text-center pl-[17px] text-[15px] font-IRANYekanBold text-mainColor2">عملیات</th>
                    </tr>
                ) : null}
                {writersList?.length > 0
                    ? writersList?.map((item, index) => (
                          <tr key={item?.jobId || index} className="h-[56px] w-full border-b-2 border-borderGray">
                              <th className="text-[15px] text-right pr-[17px] font-IRANYekanBold">{index + 1 + ((page - 1) * row)}</th>
                              <th className="text-[15px] text-right font-IRANYekanBold">{item?.title || "—"}</th>
                              <th className="text-[15px] text-right font-IRANYekanBold">{item?.company || "—"}</th>
                              <th className="text-[15px] text-right font-IRANYekanBold">{item?.location || "—"}</th>
                              <th className="text-[15px] text-right font-IRANYekanBold">{item?.countryName || "—"}</th>
                              <th className="text-[15px] text-right font-IRANYekanBold" dir="ltr">
                                  {item?.userEmail || `${item?.userName || ""} ${item?.userFamily || ""}`.trim() || "—"}
                              </th>
                              <th className="text-[15px] text-right font-IRANYekanBold" dir="ltr">
                                  {item?.deadline ? new Date(item.deadline).toLocaleDateString("en-GB") : "—"}
                              </th>
                              <th>
                                  <div className="flex pl-[17px] justify-center items-center">
                                      {detail == true ? (
                                          <button
                                              onClick={() => {
                                                  setData(item);
                                                  setShowDetailModal(true);
                                              }}
                                              className="ml-[11px]"
                                          >
                                              <Detail />
                                          </button>
                                      ) : null}
                                      {deleted == true ? (
                                          <button
                                              onClick={() => {
                                                  setData(item);
                                                  setShowDeleteModal(true);
                                              }}
                                          >
                                              <Delete />
                                          </button>
                                      ) : null}
                                  </div>
                              </th>
                          </tr>
                      ))
                    : null}
            </table>
            <div className="w-full py-3 px-3">
                <div className="flex items-center justify-between">
                    <div className="flex items-center">
                        <p className="text-sm text-right px-4 font-IRANYekanMedium">تعداد ردیف در هر صفحه :</p>
                        <div className="flex flex-col w-[80px] ml-20 font-IRANYekanMedium">
                            <div>
                                <select
                                    name="rowNumber"
                                    id="rowNumber"
                                    value={row}
                                    onChange={(e) => {
                                        setRow(Number(e.target.value));
                                        setPage(1);
                                    }}
                                    className="text-right bg-white border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-mainColor focus:border-mainColor block w-full px-2 py-1"
                                >
                                    <option value="5">۵</option>
                                    <option value="10">۱۰</option>
                                    <option value="25">۲۵</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center font-IRANYekanMedium">
                        <p className="text-sm text-right pr-4 mx-2">
                            {count > 0 ? ((page - 1) * row) + 1 : 0}-{count < row * page ? count : row * page} از {count}
                        </p>
                        <div className="flex mr-2">
                            <button onClick={() => setPage(page + 1)} disabled={count <= row * page} className="mx-2">
                                <Right />
                            </button>
                            <button onClick={() => setPage(page - 1)} disabled={page == 1 ? true : false} className="mx-2">
                                <Left />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MainAdminJobsTable;